import { Group, Button, Select } from '@mantine/core';
import { useForm } from '@mantine/form';

import type { TShop, TShopAddCurrencyParams } from '../store/types';

type FormData = Partial<TShopAddCurrencyParams>;

type Props = {
  currencies: string[];
  shop: TShop;
  onSubmit: (params: TShopAddCurrencyParams) => void;
  onClose: () => void;
};

export const AddShopCurrencyForm = (props: Props) => {
  const { currencies, shop, onSubmit, onClose } = props;

  const form = useForm<FormData>({
    mode: 'uncontrolled',
    initialValues: {},
    validate: {
      currency: (value) => !value ? 'Выберите валюту' : null,
    },
  });

  const handleSubmit = (values: FormData) => {
    const params: TShopAddCurrencyParams = {
      shopId: shop.id,
      currency: values.currency ?? '',
    };
    onSubmit(params);
    onClose();
  };

  return (
    <form onSubmit={form.onSubmit(handleSubmit)}>
      <Select
        label="Выберите валюту"
        clearable
        data={currencies.map((currency) => ({ value: currency, label: currency }))}
        key={form.key('currency')}
        {...form.getInputProps('currency')}
      />
      <Group justify="flex-end" mt="30">
        <Button variant="outline" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button type="submit">
          Добавить
        </Button>
      </Group>
    </form>
  );
};
